


















import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({
    name: "StepsList"
})
export default class StepsList extends Vue {
    @Prop({required: true}) steps: any[];
    @Prop({required: true}) step: string;

    lineWidthOffset = 0;
    lineLeft = 0;

    mounted() {
        this.updateLine();
    }

    updateLine() {
        const getRound = (parent: HTMLElement): HTMLElement => parent.getElementsByClassName("steps-list__round")[0] as HTMLElement;

        const firstItem = getRound(this.$el.children[0] as HTMLElement);
        const lastItem = getRound(this.$el.children[this.$el.children.length - 2] as HTMLElement);

        this.lineLeft = firstItem.offsetLeft + 20;
        this.lineWidthOffset = lastItem.offsetLeft + 40;
    }

    @Watch("steps")
    watchStepsHandler() {
        this.$nextTick(() => {
            this.updateLine();
        })

    }
}
